import Footer from '../../components/Footer'
import HomeHeader from '../../components/HomeHeader'
import MaintenanceContent from './components/MaintenanceContent'
import Sidebar from '../../components/SideBar'
import { TFeatureFlags } from '../../store/modules/posthog/types'

const Maintenance: React.FC<{ featureFlag: TFeatureFlags }> = (props) => {
  return (
    <>
      <Sidebar />
      <HomeHeader />
      <MaintenanceContent featureFlag={props.featureFlag} />
      <Footer />
    </>
  )
}

export default Maintenance
